"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryImageWrapper = exports.PrimaryImageWrapper = exports.ImageWrapper = exports.BackgroundWrapper = exports.BackgroundImage = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _coreMixins = require("@legacy-vfuk/core-mixins");

var _coreImage = require("@legacy-vfuk/core-image");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var BackgroundWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ImageContainerstyle__BackgroundWrapper",
  componentId: "sc-144wknd-0"
})(function (props) {
  return (0, _styledComponents.css)(["width:100%;height:", "px;overflow:hidden;", " ", ""], props.imageHeight.sm, _coreMixins.respondTo.md((0, _styledComponents.css)(["height:", "px;"], props.imageHeight.md)), _coreMixins.respondTo.lg((0, _styledComponents.css)(["height:", "px;"], props.imageHeight.lg)));
});

exports.BackgroundWrapper = BackgroundWrapper;

var ImageWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ImageContainerstyle__ImageWrapper",
  componentId: "sc-144wknd-1"
})(function () {
  return (0, _styledComponents.css)(["width:100%;height:100%;position:relative;"]);
});

exports.ImageWrapper = ImageWrapper;

var PrimaryImageWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ImageContainerstyle__PrimaryImageWrapper",
  componentId: "sc-144wknd-2"
})(function (props) {
  return (0, _styledComponents.css)(["max-width:296px;position:absolute;left:50%;transform:translateX(-50%);height:inherit;", " ", "{width:100%;height:100%;object-fit:contain;}", " ", " ", ""], _coreMixins.respondTo.lg((0, _styledComponents.css)(["max-width:300px;"])), _coreImage.ImageStyles.Image, props.primaryVerticalAlign === 'top' && (0, _styledComponents.css)(["top:0;"]), props.primaryVerticalAlign === 'bottom' && (0, _styledComponents.css)(["bottom:0;"]), props.primaryVerticalAlign === 'middle' && (0, _styledComponents.css)(["top:50%;transform:translateX(-50%) translateY(-50%);"]));
});

exports.PrimaryImageWrapper = PrimaryImageWrapper;

var SecondaryImageWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ImageContainerstyle__SecondaryImageWrapper",
  componentId: "sc-144wknd-3"
})(function (props) {
  return (0, _styledComponents.css)(["position:absolute;max-width:188px;", " ", ":0;", ":0;"], _coreMixins.respondTo.lg((0, _styledComponents.css)(["max-width:300px;"])), props.secondaryVerticalAlign, props.horizontalAlign);
});

exports.SecondaryImageWrapper = SecondaryImageWrapper;

var BackgroundImage = _styledComponents["default"].div.withConfig({
  displayName: "ImageContainerstyle__BackgroundImage",
  componentId: "sc-144wknd-4"
})(function (props) {
  return (0, _styledComponents.css)(["width:100%;height:inherit;position:absolute;background-color:", ";", " ", ""], props.backgroundColor, props.contentAlignment === 'right' && (0, _styledComponents.css)(["transform:translateX(calc(-100% + ", "px));"], props.backgroundImageWidth), props.backgroundImage && (0, _styledComponents.css)(["", ";"], (0, _coreMixins.backgroundImage)(props.backgroundImage)));
});

exports.BackgroundImage = BackgroundImage;
//# sourceMappingURL=ImageContainer.style.js.map